var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"footer"},[_c('p',{attrs:{"id":"ayat"}},[_vm._v("2025")]),_c('p',{attrs:{"id":"copyright"}},[_vm._v("SikuRaja V.2.28 © otnielpangkung - 2022")])])
}]

export { render, staticRenderFns }